import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

/**
 * Shared public footer.
 *
 * Carries the USP #7 "how we make money" link and the mandatory Swan legal
 * mention (CLAUDE.md §1 — white-label disclosure: embedded banking services
 * are powered by Swan, an EMI; Clari is never presented as a bank).
 * RTL-safe: layout uses flex + logical spacing only.
 */
export function Footer() {
  const { t } = useTranslation(['common', 'business_model'])

  return (
    <footer className="border-t border-border bg-bg">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-4 px-6 py-8">
        <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
          <Link to="/business-model" className="text-text-muted transition-colors hover:text-text">
            {t('business_model:footer_link')}
          </Link>
        </nav>
        <p className="max-w-3xl text-xs leading-relaxed text-text-subtle">
          {t('common:footer.swan_notice')}
        </p>
      </div>
    </footer>
  )
}
